export default [
  {
    path: '/orders',
    name: 'orders',
    component: () =>
      import(/* webpackChunkName: "orders" */
        /* webpackMode: "lazy" */
        `./views/OrderList.vue`)
  },
  {
    path: '/orders/draft',
    name: 'draft-order',
    component: () =>
      import(/* webpackChunkName: "orders" */
        /* webpackMode: "lazy" */
        `./views/OrderDraft.vue`)
  },
  {
    path: '/orders/draft/:id',
    name: 'draft-order-saved',
    component: () =>
      import(/* webpackChunkName: "orders" */
        /* webpackMode: "lazy" */
        `./views/OrderDraft.vue`)
  },
  {
    path: '/orders/:id',
    name: 'single-order',
    component: () =>
      import(/* webpackChunkName: "orders" */
        /* webpackMode: "lazy" */
        `./views/OrderItem.vue`)
  }
]
